import React from "react";

export const excludedFromAnnotationClassName = "exclude-from-annotation";
const ExcludeFromAnnotation: React.FC = ({ children }) => {
  return <span className={excludedFromAnnotationClassName}>{children}</span>;
};

export default ExcludeFromAnnotation;
